export default {
    common: {
        email: 'Email',
        password: 'Password',
        learnMore: 'Learn More',
        sendEmail: 'Send Email'
    },
    login: {
        title: 'Login to Thundersend.me',
        rememberMe: 'Remember Me',
        forgotPassword: 'Forgot Password',
        login: 'Login',
        noAccount: "Don't have an account?",
        register: 'Register'
    },
    footer: {
        introduce: 'Thundersend - Your Web3 Message Filter!',
        privacy: 'Privacy Policy',
        protocal: 'Terms of Service',
        aboutUs: 'About Us',
        toUse: 'How to Use',
        contact: 'Contact Us',
        link: 'Links',
        home: 'Home',
        function: 'Features',
        subscribe: 'Popular Subscriptions',
        qa: 'FAQ',
        course: 'Basic Tutorial',
        service: 'Terms of Service',
        privacy: 'Privacy Policy'
    },
    home: {
        hero: {
            title: 'Thundersend, Your Web3 Message Filter',
            subtitle: 'Thundersend helps Web3 professionals create personalized channels to quickly filter messages from Telegram/Twitter(X), enabling instant message delivery',
            startButton: 'Get Started',
            tutorialButton: 'Tutorial Video'
        },
        features: {
            title: 'Key Features of Thundersend',
            subtitle: 'With Thundersend, you can easily get the information you want from Web3 communities/channels',
            items: {
                subscription: {
                    title: 'Abundant Popular Subscriptions',
                    description: 'Thundersend has integrated extensive popular subscriptions for Web3/crypto users, allowing you to copy these subscriptions to quickly achieve your filtering needs.'
                },
                filter: {
                    title: 'Flexible Keyword Filtering',
                    description: 'You can achieve various complex keyword combinations through visual configuration, such as include/exclude/greater than/less than, etc.'
                },
                push: {
                    title: 'Multiple Listener Methods',
                    description: 'You can push filtered messages in real-time through various IM tools such as Telegram/WeCom/Feishu Lark.'
                },
                test: {
                    title: 'Quick Testing Tools',
                    description: 'Through filter and push bot testing tools, you can quickly verify your filter rules and push channels for easy adjustment.'
                }
            }
        },
        faq: {
            title: 'FAQ',
            subtitle: 'Here are solutions to problems you might encounter while using Thundersend service',
            questions: {
                source: {
                    question: 'How do I confirm that my submitted message source (group) has been included?',
                    answer: "After logging in, go to 'My Channels', search for the feed you just added in the message source list on the left, click on the feed name, and if there are collected messages in the pop-up box, it proves that the collection was successful."
                },
                portal: {
                    question: 'How do I verify filter rules?',
                    answer: "After logging in, go to the 'My Channels' page, find the filter you want to verify rules for at the bottom right, click edit, and in the test filter section above, you can manually input one messages to verify your filter rules."
                },
                rule: {
                    question: 'Why am I not receiving push messages?',
                    answer: "Your listening method settings may have issues. Please go to the 'Configure My Listening Method' page and test the channels of the listening method individually: if the listening method test passes, then please test your filter rules."
                },
                complex: {
                    question: 'How to copy a public channel to create my own exclusive channel?',
                    answer: 'You can click the copy button in the public channel to generate your own channel (this feature is for VIP users only).'
                },
                push: {
                    question: 'How do I set up complex combination filter rules?',
                    answer: 'Enter the filter settings interface, click filter rule settings, select keyword combination settings. You can set up combinations of conditions like include, greater than, equal to, less than, exclude, etc. Conditions are combined with AND operation using semicolons.'
                },
                multiple: {
                    question: 'Can I filter messages from multiple sources in one filter?',
                    answer: 'The system supports setting multiple message sources in one filter, and in various condition settings, commas represent OR, while semicolons represent AND.'
                }
            }
        },
        contact: {
            title: 'Contact Us',
            subtitle: 'Through Official Telegram Support Group',
            social: {
                twitter: {
                    title: 'Official X/Twitter',
                    handle: '@thundersendme'
                },
                telegram: {
                    title: 'Official Telegram Support Groups(recommend)',
                    chinese: {
                        label: 'Chinese Group:',
                        handle: '@thundersendSupport_CN'
                    },
                    english: {
                        label: 'English Group:',
                        handle: '@thundersendSupport_EN'
                    }
                },
                email: {
                    title: 'Email Us'
                }
            },
            email: {
                title: 'Email Us',
                recipient: 'Official Thundersend',
                emailAddress: 'service@thundersend.me',
                placeholder: 'Your Suggestions'
            }
        }
    },
    channel: {
        banner: {
            desc: 'Monitor public channels, track market trends',
            title: 'Public Channels'
        },
        stats: {
            owner: 'Owner',
            sources: 'Sources',
            followers: 'Followers',
            tags: 'Tags'
        },
        button: {
            copy: 'Copy This Channel (VIP Only)',
            listen: 'Listen to This Channel',
            cancelListen: 'Cancel Listening'
        },
        content: {
            latest: 'Latest Messages',
            statistics: 'Distribution Statistics'
        }
    },
    config: {
        banner: {
            desc: 'You can add multiple listening methods to receive messages',
            title: 'Configure My Listening Methods'
        },
        notice: 'Thundersend allows you to receive channel messages through multiple methods, which you can configure here',
        methods: {
            telegram: {
                title: 'Method 1: Listen via Telegram Bot'
            },
            wechat: {
                title: 'Method 2: Listen via WeCom Webhook Bot'
            },
            feishu: {
                title: 'Method 3: Listen via Feishu Webhook Bot'
            },
            custom: {
                title: 'Method 4: Listen via Custom Webhook Bot'
            },
            vipTip: '* Add new listening channel under this method (VIP Only)'
        },
        form: {
            labels: {
                telegramBot: 'Telegram Bot',
                uniqueId: 'Listening Method Unique ID',
                robotUrl: 'Enterprise Bot URL',
                testChannel: 'Test Listening Channel',
                returnStatus: 'Return Status',
                returnResult: 'Return Result'
            },
            placeholders: {
                telegramBot: 'thundersend_bot',
                autoGenerate: 'Auto Generate',
                wechatWebhook: 'Please enter WeCom webhook bot URL',
                testMessage: 'Please enter test message',
                customName: 'Custom Name',
                feishuWebhook: 'Please enter Feishu webhook bot URL',
                customWebhook: 'Please enter Custom webhook bot URL'
            }
        },
        button: {
            addFriend: 'Add Friend',
            save: 'Save',
            test: 'Test This Channel',
            testConnection: 'Test Connection',
            sendTest: 'Send Test Message',
            cancel: 'Cancel',
            bindSuccess: 'Successfully bound',
            bindFail: 'Binding failed',
            notFoundAccount: 'The bound Telegram account was not found',
            telegramInfo: "For the first binding of the Telegram bot, please click the 'Add Friend' button below, go to the conversation with the thundersendme bot in Telegram and click 'Start', then return to this page to save; if the binding fails, please cancel and rebind."
        }
    },
    layout: {
        menu: {
            home: 'Home',
            hot: 'Public Channels',
            mine: 'My Channels',
            insight: 'Insight',
            subscribe: 'Subscribe',
            notice: 'Notice'
        },
        button: {
            login: 'Login',
            onLight: 'Light',
            closeLight: 'Dark'
        }
    },
    hot: {
        banner: {
            desc: 'Monitor public channels, track market trends',
            title: 'Public Channels'
        },
        stats: {
            channels: 'Channels',
            sources: 'Sources',
            followers: 'Followers'
        },
        button: {
            createChannel: 'Create My Channel',
            listenSetting: 'Configure Listening Settings',
            listen: 'Listen to Channel',
            unlisten: 'Unsubscribe',
            copyChannel: 'Copy Channel (VIP Only)'
        },
        list: {
            channel: 'Channel',
            popular: 'Popular',
            latest: 'Latest',
            tag: 'Tag',
            allTags: 'All',
            jumpChannel: "Didn't find the channel you were looking for? Click here to create your exclusive channel"
        },
        search: {
            placeholder: 'Enter keywords'
        },
        table: {
            channel: 'Channel',
            tags: 'Tags',
            sources: 'Sources',
            followers: 'Subscribers',
            pushMethod: 'Lisener Method',
            actions: 'Actions',
            unit: 'items',
            person: 'people'
        }
    },
    insight: {
        banner: {
            desc: 'Analyze hot contracts, currencies/KOLs, and find investments',
            title: 'Insights'
        },
        card: {
            project: {
                title: 'Hot Projects'
            },
            currency: {
                title: 'Hot Currencies'
            },
            kol: {
                title: 'Hot KOLs'
            }
        },
        filter: {
            chainType: 'Chain Type',
            timeType: 'Time Range'
        },
        table: {
            rank: 'Rank',
            contract: 'Contract/Address',
            amount: 'Amount',
            currency: 'Currency',
            kol: 'Twitter/X USER'
        },
        button: {
            copy: 'Copy',
            insight: 'Analyze',
            back: 'Back'
        },
        kol: {
            name: 'Name',
            account: '@Account'
        },
        content: {
            latest: 'Latest Messages',
            statistics: 'Distribution Statistics',
            timeWarning: 'Free members do not support switching time.'
        }
    },
    mine: {
        banner: {
            desc: 'Create my exclusive channel (flexible filter conditions)',
            title: 'My Channels'
        },
        source: {
            title: 'Telegram Sources',
            button: {
                new: 'New Source'
            },
            tags: {
                all: 'All'
            },
            search: {
                placeholder: 'Use group (channel) name/account name/URL to search'
            }
        },
        form: {
            title: {
                create: 'Create New Channel',
                edit: 'Edit Channel'
            },
            label: {
                name: 'Channel Name',
                no: 'Channel Number',
                source: 'Source',
                rules: 'Set Rules',
                showRules: 'Show Rules in Message',
                pushRobot: 'Listening Method',
                isPublic: 'Public',
                customWords: 'Custom Name'
            },
            placeholder: {
                name: 'Please enter channel name',
                no: 'Please enter channel number',
                customWords: 'Please enter custom name'
            },
            button: {
                chooseSource: 'Choose Source',
                setRules: 'Set Message Content Filter Rules'
            },
            radio: {
                show: 'Show',
                hide: 'Hide',
                yes: 'Yes',
                no: 'No'
            },
            noRules: 'No conditions set'
        },
        test: {
            title: 'Channel Test',
            label: {
                input: 'Test Message Input',
                status: 'Return Status',
                result: 'Return Result'
            }
        },
        channel: {
            search: {
                placeholder: 'Search by keyword'
            },
            button: {
                configListen: 'Configure Listening Method',
                addListen: '+Add Listening Method'
            }
        },
        table: {
            channel: 'My Created Channels',
            status: 'Status',
            source: 'Source',
            listenMethod: 'Listening Method',
            actions: 'Actions'
        },
        button: {
            save: 'Save',
            cancel: 'Cancel',
            test: 'Test',
            edit: 'Edit',
            invalid: 'Invalid'
        }
    },
    notice: {
        banner: {
            title: 'Announcements'
        },
        list: {
            time: 'Time',
            desc: 'Description'
        },
        dialog: {
            title: 'Announcement Details',
            content: 'Content'
        }
    },
    profile: {
        user: {
            logout: 'Logout',
            registerTime: 'Registered on {time}',
            loginTime: 'Last login: {time}',
            memberExpiry: 'Membership Expires',
            inviteButton: 'Invite Friends to Extend Membership'
        },
        info: {
            title: 'Basic Information',
            email: 'Email',
            nickname: 'Nickname',
            inviteCode: 'Invitation Code',
            copyInvite: 'Copy Invitation Link',
            lastModified: 'Last Modified'
        },
        security: {
            title: 'Security Information',
            loginMethod: 'Login Method',
            emailPassword: 'Email + Password',
            password: 'Login Password',
            emailVerification: 'Email Verification',
            changePassword: 'Change Password'
        },
        stats: {
            title: 'Overview',
            subscribed: 'Subscribed Channels',
            created: 'Created Channels',
            pushed: 'Messages Pushed within 7 Days'
        },
        action: {
            manageSource: 'Manage Sources',
            manageListen: 'Manage Listening Methods'
        },
        invite: {
            title: 'My Invited Users',
            invitedUser: 'Invited user',
            noData: 'No invitation records'
        }
    },
    subscribe: {
        title: 'Our Membership System',
        plans: {
            period: '/month',
            free: {
                title: 'Free User',
                features: {
                    sources: '{count} Source',
                    channels: '{count} Subscribed Channel / {count} Exclusive Channel',
                    methods: 'Listening Methods/Channels',
                    telegram: 'Telegram - Supported',
                    wecom: 'WeCom - Not Supported',
                    feishu: 'Feishu - Not Supported',
                    webhook: 'Custom Webhook - Not Supported',
                    interval: '1 Minute Push Interval'
                }
            },
            vip: {
                title: 'VIP Member',
                features: {
                    sources: '{count} Sources',
                    channels: '{count} Subscribed Channels / {count} Exclusive Channels',
                    methods: 'Listening Methods/Channels',
                    telegram: 'Telegram - Supported',
                    wecom: 'WeCom - Multi-channel Support',
                    feishu: 'Feishu - Multi-channel Support',
                    webhook: 'Custom Webhook - Not Supported',
                    realtime: 'Real-time Push'
                }
            },
            svip: {
                title: 'Super VIP Member',
                features: {
                    sources: 'Unlimited Sources',
                    channels: '{count} Subscribed Channels / {count} Exclusive Channels',
                    methods: 'Listening Methods/Channels',
                    telegram: 'Telegram - Supported',
                    wecom: 'WeCom - Multi-channel Support',
                    feishu: 'Feishu - Multi-channel Support',
                    webhook: 'Custom Webhook - Multi-channel Support',
                    realtime: 'Real-time Push'
                }
            }
        },
        button: {
            join: 'Join Now',
            buy: 'Buy Now',
            link: 'Link Now'
        },
        dialog: {
            payment: {
                scan: 'Please scan the QR code to pay with USDT',
                binance: 'You can also transfer payment via Binance ID [910336933]',
                reminder: 'Special reminder: Please enter your registered email when making payment'
            }
        }
    },
    rulesSettingPlaceholder: {
        notsetting: "Leave empty when no conditions are set",
        include: "For multiple keywords, separate with comma ',' - matches if any keyword is found",
        exclude: "For multiple excluded keywords, separate with comma ',' - matches if none of the keywords are found",
        greaterthan: "balance:>10, where 'balance' is keyword and ':' is the separator for the value",
        equalto: "balance:=10, where 'balance' is keyword and ':' is the separator for the value",
        lessthan: "balance:<10, where 'balance' is keyword and ':' is the separator for the value",
        inccontract: "Contract types, e.g.: eth,sol, separate multiple types with comma",
        aiprompt: "Separate conditions with '、', matches only when all conditions are met",
        defaultValue: "include[keyword1,keyword2]、exclude[keyword3]、keyword4>0、keyword5<1500",
        greaterthanWarning: "< and = are not supported!",
        equaltoWarning: "< and > are not supported!",
        lessthanWarning: "> and = are not supported!"
    },

    "loginPage": {
        "emailRequired": "Please enter your email address",
        "passwordRequired": "Please enter your password",
        "loginSuccess": "Login successful",
        "loginFailed": "Login failed"
    },
    "reset": {
        "resetPassward": "Reset Password",
        "getCode": "Get Verification Code",
        "emailRequired": "Please enter your email address",
        "codeRequired": "Please enter reset verification code",
        "next": "Next",
        "goBack": "Back",
        "vaildEamil": "Please enter a valid email address",
        "verCodeRequired": "Please enter verification code",
        "resetSuccess": "Password reset successful",
        "resetFailed": "Password reset failed",
        "verCodeSend": "Verification code sent"
    },
    "minePage": {
        "fold": "Collapse",
        "more": "More",
        "filterTag": "Filter Tags",
        "addTag": "Add Tag",
        "countUnit": "items",
        "rule": "Rule",
        "connector": "Connector",
        "or": "OR",
        "and": "AND",
        "confirm": "Confirm",
        "cancel": "Cancel",
        "addSource": "New Message Source",
        "editSource": "Edit Message Source",
        "serialNumber": "Number",
        "sourceUrl": "Source URL",
        "sourceAccount": "Source Account",
        "sourceName": "Source Name",
        "customName": "Custom Name",
        "sourceTag": "Source Tags",
        "selectSource": "Please select my (or public) message source",
        "commonSource": "Public Sources",
        "mySource": "My Sources",
        "quickSearch": "Quick Search",
        "name": "Name",
        "search": "Search",
        "reset": "Reset",
        "selectSourceTip": "Please select data source"
    },
    "register": {
        "register": "Register",
        "enterEmail": "Please enter your email",
        "enterPassword": "Please enter your password",
        "enterVerCode": "Please enter email verification code",
        "inviteCode": "Invitation Code (Optional)",
        "hadAccount": "Already have an account",
        "clickLogin": "Click to login",
        "validPassword": "Password must be at least 6 characters",
        "registerSuccess": "Registration successful"
    },
    "hotPage": {
        "createAt": "Created at"
    },
    "profileJs": {
        "before": "ago",
        "copySuccess": "Copied successfully"
    },
    "insightJs": {
        "minutes": "minutes",
        "getDataFailed": "Failed to get data"
    },
    "channelJs": {
        "listenSuccess": "Successfully subscribed",
        "confirmUnlisten": "Are you sure you want to unsubscribe from this channel?",
        "tip": "Tip",
        "unlistenSuccess": "Successfully unsubscribed"
    },
    "hotJs": {
        "defaultSort": "Default Sort",
        "subscribeCount": "Subscriber Count",
        "latest": "Latest",
        "sort": "Sort",
        "selectPushWay": "Please select listener method"
    },
    "configJs": {
        "customReamrk": "Please add a custom name",
        "customRemarkUsed": "Custom name already exists",
        "saveSuccess": "Saved successfully",
        "saveFailed": "Save failed, please try again later",
        "confirmCancelRobot": "Are you sure you want to cancel this notification channel?",
        "cancelSuccess": "Successfully invalidated"
    },
    "commonJs": {
        "day": "day",
        "hour": "hour",
        "minute": "minute",
        "second": "second"
    },
    "mineSources": {
        "title": "Message Source Management",
        "subTitle": "My Message Sources",
        "addSource": "Add New Source",
        "editSource": "Edit Source",
        "tags": "Source Tags",
        "pleaseMsgUrl": "Please enter source URL",
        "deleteConfirm": "After invalidation, messages from this source will no longer be pushed. Confirm invalidation?",
        "prompt": "Prompt",
        "deleteSuccess": "Successfully invalidated",
        "validUrl": "Invalid URL",
        "warning1": "System does not support Telegram bot addresses, please enter Telegram group!",
        "warning2": "This is not a valid Telegram link!",
        "inputCustomName": "Please enter custom name",
        "selectSource": "Please select message source",
        "selectRobot": "Please select listening method",
        "deleteFilterConfirm": "Are you sure you want to invalidate this filter?",
        "channerSearChPlaceholder": 'Name/Source URL/Source Account',
        "loginListener": 'Login to subscribe',
        "mineListener": 'My Subscriptions',
        "sendMsgNum": 'Pushed message count',
        "select": 'Select',
        "comingSoon": 'Coming Soon',
        "freeCopayWarning": 'Free members cannot copy channels',
        "memberType": 'Membership type',
        "membership": 'View Membership Benefits Plan',
        "autoGenerate": 'Auto General',
        "inputNameWarning": 'Please enter a name',
        "generInviteCode": 'Generate invitation code',
        "remark": 'use remark',
        "stop": 'Stop',
        "enable": 'Start',
        "copyInfo": 'Copy Information',
        "copyInfoSuccess": 'Channel information has been copied.',
        "linkShared": 'Link Sharing',
        "copyLink": 'Copy Link',
        "sendService": 'High-Speed Push Service',
        "linkCustomService": 'Contact Customer Service',
        "publicSource": 'Public message sources are not allowed to be invalidated'
    }
}